import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PrecisionTab from '@components/common/Dashboard/DashboardTabs/PrecisionTab';
import { MoreDropDown } from '@components/common';
import { Button } from 'antd';
import { PRECISION_POLICY_PATH, CHANGE_LOG_PATH } from '@utils/constants';
import { precisionPolicySchedulingFeatureSelector } from '@store/common/selectors';
import { ViewTypes } from '@store/policies/precisionPolicy/reducers';
import { ButtonsWrapper, StyledTabs, ActionsWrapper } from './styled';
import ScheduleModal from '../ScheduleModal';
import { ViewAllSchedulesButton } from '../ScheduleList';

interface IProps {
  editMode: boolean;
  onCancel: () => void;
  onOk: () => void;
  onToggle: () => void;
  canEdit?: boolean;
  activeView: ViewTypes;
}

const Buttons: React.FC<IProps> = ({
  editMode,
  onCancel,
  onOk,
  onToggle,
  canEdit = false,
  activeView,
}) => {
  const schedulingFeatureFlag = useSelector(precisionPolicySchedulingFeatureSelector);
  const dropdown = (
    <ActionsWrapper>
      {schedulingFeatureFlag && (
        <>
          <ViewAllSchedulesButton />
          <ScheduleModal canEdit={canEdit} />
        </>
      )}
      {activeView === ViewTypes.policies && (
        <MoreDropDown>
          {canEdit && (
            <span role="button" onClick={onToggle}>
              Re-order Policies
            </span>
          )}
          <Link to={`${CHANGE_LOG_PATH}?type=precision_policy&back=${PRECISION_POLICY_PATH}`}>
            Change Log
          </Link>
        </MoreDropDown>
      )}
    </ActionsWrapper>
  );
  return (
    <ButtonsWrapper>
      <StyledTabs>
        <PrecisionTab />
      </StyledTabs>
      {editMode ? (
        <>
          <Button onClick={onCancel} key="cancel">
            Cancel
          </Button>
          <Button type="primary" onClick={onOk} key="save">
            Save
          </Button>
        </>
      ) : (
        dropdown
      )}
    </ButtonsWrapper>
  );
};

export default React.memo(Buttons);
